import React, { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function AdminLogin() {
    const { admin, login, loading } = useAuth();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [err, setErr] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const navigate = useNavigate();

    if (loading) return null;
    if (admin) return <Navigate to="/admin" replace />;

    const onSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        setErr("");
        const res = await login(email, password);
        setSubmitting(false);
        if (res.ok) navigate("/admin");
        else setErr(res.error || "Login failed");
    };

    return (
        <section className="min-h-[100svh] flex items-center justify-center pt-24" data-testid="admin-login">
            <div className="container-prose max-w-md">
                <p className="eyebrow text-center">Private · Admin</p>
                <h1 className="font-serif text-4xl md:text-5xl mt-4 text-center">Sign in.</h1>
                <form
                    onSubmit={onSubmit}
                    className="mt-12 border border-[hsl(var(--brass)/0.5)] bg-[hsl(var(--cream))] p-8 md:p-10 space-y-6"
                    data-testid="admin-login-form"
                >
                    <div className="field">
                        <label htmlFor="admin-email">Email</label>
                        <input
                            id="admin-email"
                            type="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            data-testid="admin-email-input"
                        />
                    </div>
                    <div className="field">
                        <label htmlFor="admin-password">Password</label>
                        <input
                            id="admin-password"
                            type="password"
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            data-testid="admin-password-input"
                        />
                    </div>
                    {err && (
                        <p className="text-[13px] text-[hsl(var(--destructive))]" data-testid="admin-login-error">
                            {err}
                        </p>
                    )}
                    <button
                        type="submit"
                        disabled={submitting}
                        className="btn-primary w-full justify-center disabled:opacity-60"
                        data-testid="admin-login-submit"
                    >
                        {submitting ? "Signing in…" : "Sign in"}
                    </button>
                </form>
            </div>
        </section>
    );
}
